import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryforceurbaniaonrentinpune() {



  const cardData = {
"keyword": "Luxury Force Urbania On Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers premium Luxury Force Urbania on Rent in Pune for corporate travel, wedding transportation, airport transfers, family trips, and outstation tours. Our Force Urbania fleet provides ultra-comfortable pushback seats, advanced suspension, powerful AC, spacious interiors, LED lighting, and a premium travel experience. With professional drivers and well-maintained vehicles, we ensure safe, stylish, and comfortable group travel across Pune and Maharashtra.",

"topPlaces": [
{
"title": "Kaas Plateau",
"description":
"Kaas Plateau, also called the Valley of Flowers of Maharashtra, is a UNESCO World Heritage site famous for seasonal wildflowers and biodiversity. It is a popular monsoon tourism destination for group travel from Pune."
},
{
"title": "Kolad",
"description":
"Kolad is an adventure destination famous for river rafting on the Kundalika River, camping, and outdoor activities. It is widely chosen for group adventure trips from Pune."
},
{
"title": "Dapoli",
"description":
"Dapoli is a peaceful coastal destination known for clean beaches, dolphin spotting, and calm surroundings. It is ideal for family and group tours from Pune using buses."
},
{
"title": "Shirdi",
"description":
"Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba. It attracts devotees from across the country and is a highly preferred group travel destination from Pune using 32 seater buses for comfortable spiritual tours."
},
{
"title": "Nashik",
"description":
"Nashik is a major pilgrimage and wine tourism destination known for Trimbakeshwar Temple, river ghats, and vineyards. It is a popular group travel route from Pune for both religious and leisure tours."
},
{
"title": "Bhimashankar",
"description":
"Bhimashankar is a famous Jyotirlinga temple surrounded by dense forests and wildlife sanctuary. It is a top spiritual and nature trekking destination for group trips from Pune."
},
{
"title": "Alibaug",
"description":
"Alibaug is a coastal beach destination known for clean beaches, sea forts, and peaceful surroundings. It is ideal for weekend group tours and beach outings from Pune using buses."
},
{
"title": "Murud-Janjira",
"description":
"Murud-Janjira is famous for its historic sea fort located on an island. It is a popular coastal heritage sightseeing destination for group travelers from Pune."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic monsoon destination known for waterfalls, foggy mountains, and lush greenery. It is one of the most popular short road trips from Pune for group travel."
},

{
"title": "Ratnagiri",
"description":
"Ratnagiri is a beautiful Konkan coastal destination known for beaches, forts, Alphonso mangoes, and long scenic road trips. It is popular for long-distance group travel from Pune."
}
],



services: [
  {
    name: "Luxury Force Urbania on Rent in Hadapsar",
    description: "Luxury Force Urbania on rent in Hadapsar service provides premium transportation for airport transfers, family vacations, corporate outings, wedding travel, and outstation journeys from Hadapsar Pune. Spacious luxury seating and modern interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Hadapsar Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "13 Seater Force Urbania on Rent in Pune",
    description: "13 seater Force Urbania on rent in Pune service offers comfortable premium transportation for family tours, sightseeing journeys, airport transfers, business travel, and outstation trips. Spacious seating and luggage capacity ensure pleasant travel experiences suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 13 seater Urbania reservations."
  },
  {
    name: "17 Seater Force Urbania on Rent in Pune",
    description: "17 seater Force Urbania on rent in Pune service provides luxurious transportation for corporate events, family vacations, educational tours, pilgrimage journeys, and tourist travel. Comfortable interiors and smooth highway performance ensure premium travel experiences suitable for larger passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 17 seater Urbania reservations."
  },
  {
    name: "Urbania Hire in Pune for Outstation",
    description: "Urbania hire in Pune for outstation service offers premium long-distance transportation for Goa tours, Mahabaleshwar trips, Konkan Darshan, family vacations, and pilgrimage journeys. Spacious luxury seating and luggage space ensure smooth highway travel suitable for tourist and business groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Pune to Lonavala Urbania Bus on Rent",
    description: "Pune to Lonavala Urbania bus on rent service provides comfortable hill station transportation for picnic trips, sightseeing tours, corporate outings, and family vacations from Pune. Spacious luxury interiors and smooth expressway travel ensure pleasant journeys suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Lonavala Urbania reservations."
  },
  {
    name: "Pune to 5 Jyotirlinga Darshan Urbania on Rent",
    description: "Pune to 5 Jyotirlinga Darshan Urbania on rent service offers reliable premium transportation for devotees visiting sacred Jyotirlinga temples across Maharashtra and nearby regions. Spacious seating and smooth long-distance travel ensure comfortable pilgrimage journeys suitable for spiritual groups and families. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Jyotirlinga Urbania reservations."
  },
  {
    name: "Pune Darshan Urbania on Rent",
    description: "Pune Darshan Urbania on rent service provides stylish and spacious transportation for city sightseeing tours, educational visits, tourist travel, and family outings across Pune attractions. Comfortable luxury interiors ensure smooth local travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and commercial locations across Pune. Flexible booking options allow convenient Pune Darshan Urbania reservations."
  },
  {
    name: "Pune to Nashik Urbania on Rent",
    description: "Pune to Nashik Urbania on rent service offers premium transportation for pilgrimage tours, wine tourism, sightseeing journeys, and family vacations from Pune. Spacious seating and modern interiors ensure comfortable highway travel suitable for tourist and business groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Nashik Urbania reservations."
  },
  {
    name: "Pune to Bhimashankar Urbania Bus Hire",
    description: "Pune to Bhimashankar Urbania bus hire service provides dependable premium transportation for Jyotirlinga darshan tours, spiritual journeys, sightseeing trips, and pilgrimage travel from Pune. Spacious interiors and smooth suspension ensure pleasant ghat road travel experiences suitable for devotees and tourist groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Bhimashankar Urbania reservations."
  },
  {
    name: "Pune to Ajanta Ellora Urbania Bus Hire",
    description: "Pune to Ajanta Ellora Urbania bus hire service offers luxurious transportation for heritage tourism, family vacations, educational tours, and sightseeing journeys from Pune. Comfortable seating and spacious interiors ensure pleasant long-distance travel experiences suitable for tourist and group passengers. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Ajanta Ellora Urbania reservations."
  },
  {
    name: "Luxury Force Urbania on Rent in Pune Near Me",
    description: "Luxury Force Urbania on rent in Pune near me service provides quick and reliable premium transportation for airport transfers, family tours, corporate events, and local or outstation journeys. Spacious luxury interiors ensure smooth travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient nearby Urbania reservations."
  },
  {
    name: "Luxury Force Urbania on Rent in Kothrud",
    description: "Luxury Force Urbania on rent in Kothrud service offers premium transportation for family vacations, airport transfers, office travel, sightseeing tours, and outstation journeys from Kothrud Pune. Spacious seating and elegant interiors ensure comfortable travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Kothrud Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Luxury Force Urbania on Rent in Pimpri Chinchwad",
    description: "Luxury Force Urbania on rent in Pimpri Chinchwad service provides stylish transportation for airport transfers, corporate outings, educational tours, family functions, and tourist travel. Spacious luxury seating and modern interiors ensure pleasant travel experiences suitable for local and outstation journeys. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Luxury Force Urbania on Rent for Wedding Pune",
    description: "Luxury Force Urbania on rent for wedding Pune service offers luxurious transportation for bridal parties, family members, wedding guests, and marriage event travel requirements. Spacious seating and premium interiors ensure smooth travel experiences suitable for wedding ceremonies and celebrations. Professional drivers ensure punctual pickup and reliable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding Urbania reservations."
  },
  {
    name: "Luxury Force Urbania for Corporate Travel Pune",
    description: "Luxury Force Urbania for corporate travel Pune service provides professional premium transportation for conferences, employee travel, business meetings, industrial visits, and executive journeys. Spacious luxury seating and smooth travel performance ensure comfortable journeys suitable for office teams and business passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate Urbania reservations."
  },
  {
    name: "Luxury Force Urbania for Family Trip Pune",
    description: "Luxury Force Urbania for family trip Pune service offers comfortable premium transportation for holiday vacations, sightseeing journeys, pilgrimage travel, and group tours with relatives and family members. Spacious seating and luggage space ensure smooth travel experiences suitable for local and outstation family trips. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip Urbania reservations."
  },
  {
    name: "Luxury Force Urbania for Airport Pickup Pune",
    description: "Luxury Force Urbania for airport pickup Pune service provides dependable premium transportation for tourists, corporate guests, wedding groups, and family passengers arriving at airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from Pune Airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport Urbania reservations."
  },
  {
    name: "Luxury Force Urbania for Outstation Tours Pune",
    description: "Luxury Force Urbania for outstation tours Pune service offers premium long-distance transportation for Goa trips, Konkan Darshan, Mahabaleshwar tours, pilgrimage journeys, and tourist travel. Spacious interiors and smooth highway performance ensure pleasant travel experiences suitable for families and tourist groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Luxury Force Urbania Booking Pune",
    description: "Luxury Force Urbania booking Pune service provides stylish premium transportation for weddings, corporate events, sightseeing tours, airport transfers, and outstation journeys. Spacious seating and elegant interiors ensure comfortable travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania booking reservations."
  }
],

tableData: [
  ["Luxury Force Urbania on Rent in Hadapsar", "13 Seater Force Urbania on Rent in Pune"],
  ["17 Seater Force Urbania on Rent in Pune", "Urbania Hire in Pune for Outstation"],
  ["Pune to Lonavala Urbania Bus on Rent", "Pune to 5 Jyotirlinga Darshan Urbania on Rent"],
  ["Pune Darshan Urbania on Rent", "Pune to Nashik Urbania on Rent"],
  ["Pune to Bhimashankar Urbania Bus Hire", "Pune to Ajanta Ellora Urbania Bus Hire"],
  ["Luxury Force Urbania on Rent in Pune Near Me", "Luxury Force Urbania on Rent in Kothrud"],
  ["Luxury Force Urbania on Rent in Pimpri Chinchwad", "Luxury Force Urbania on Rent for Wedding Pune"],
  ["Luxury Force Urbania for Corporate Travel Pune", "Luxury Force Urbania for Family Trip Pune"],
  ["Luxury Force Urbania for Airport Pickup Pune", "Luxury Force Urbania for Outstation Tours Pune"],
  ["Luxury Force Urbania Booking Pune", "Luxury Force Urbania on Rent in Hadapsar"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Luxury Force Urbania On Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Luxury Force Urbania rental service in Pune with premium vehicles, professional drivers, and smooth travel arrangements for corporate tours, family trips, and luxury group travel."
      },
      {
        WhyChooseheading: "Affordable Luxury Urbania Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Luxury Force Urbania on rent in Pune with transparent pricing, flexible booking plans, and premium travel facilities without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Luxury Urbania Booking Service",
        WhyChoosedescription: "Our Luxury Force Urbania rental service in Pune operates 24 hours for airport transfers, weddings, corporate events, outstation tours, VIP travel, and family vacations."
      },
      {
        WhyChooseheading: "Premium & Fully AC Luxury Urbania Vehicles",
        WhyChoosedescription: "All Luxury Force Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and equipped with premium seating for comfortable and luxurious travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Luxury Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day outstation journeys, and luxury travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "Perfect for Corporate & Family Group Travel",
        WhyChoosedescription: "Luxury Force Urbania vehicles are ideal for corporate teams, wedding guest transportation, tourist groups, VIP travel, family vacations, and premium outstation journeys from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Luxury Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation luxury transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Luxury Force Urbania on rent in Pune?", answer: "Luxury Force Urbania rental service in Pune provides premium group transportation for corporate travel, weddings, family tours, and outstation journeys." },
    { question: "Is Luxury Force Urbania booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 Luxury Force Urbania rental service in Pune." },
    { question: "Can I book Luxury Force Urbania for outstation travel?", answer: "Yes, customers can book Luxury Force Urbania vehicles for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide Luxury Force Urbania for corporate events?", answer: "Yes, Aaradhya Travels provides Luxury Force Urbania rental service for corporate meetings, office outings, conferences, and VIP employee transportation." },
    { question: "Are all Luxury Force Urbania vehicles air-conditioned?", answer: "Yes, all Luxury Force Urbania vehicles are fully air-conditioned and maintained for comfortable premium travel." },
    { question: "Can I book Luxury Force Urbania online in Pune?", answer: "Yes, customers can easily book Luxury Force Urbania rental service online or through phone booking." },
    { question: "Do you provide Luxury Force Urbania for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Luxury Force Urbania vehicles suitable for weddings, family vacations, and group tours." },
    { question: "Are Luxury Force Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Luxury Force Urbania rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Omkar Kulkarni",
    feedback:
      "A Luxury Force Urbania on rent in Pune from Aaradhya Travels made our group journey feel truly premium. The interiors were spotless, seating was extremely comfortable, and the ride quality was smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Joshi",
    feedback:
      "Aaradhya Travels provided a Luxury Force Urbania in Pune that was perfect for our family outing. The vehicle was well-maintained, spacious, and gave a very comfortable travel experience from start to finish.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Force Urbania On Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/luxury-force-urbania-on-rent-pune.jpg",
  "description": "Book Luxury Force Urbania on rent in Pune with Aaradhya Travels for premium group travel, weddings, corporate tours, airport transfers, and outstation trips. Available in 13 and 17 seater Urbania for Lonavala, Nashik, Bhimashankar, Ajanta Ellora, and Jyotirlinga tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2416"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/luxury-force-urbania-on-rent-in-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Luxury Force Urbania On Rent in Pune | 13 & 17 Seater Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Luxury Force Urbania on rent in Pune with Aaradhya Travels. Premium 13 and 17 seater Urbania available for Lonavala trips, Nashik tours, Pune darshan, Bhimashankar, Ajanta Ellora, Jyotirlinga darshan, weddings, and corporate travel."
  />

  <meta
    name="keywords"
    content="Luxury Force Urbania on rent in Hadapsar, 13 Seater Force Urbania on Rent in Pune, 17 Seater Force Urbania on Rent in Pune, Urbania Hire in Pune for Outstation, Pune to Lonavala Urbania Bus on Rent, Pune to 5 Jyotirlinga Darshan Urbania on Rent, Pune Darshan Urbania on Rent, Pune to Nashik Urbania on Rent, Pune to Bhimashankar Urbania Bus Hire, Pune to Ajanta Ellora Urbania Bus Hire"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxuryforceurbaniaonrentinpune;